module.exports = __webpack_public_path__ + "fb2bd61de4777efa1d830e1f0bdb2d59.png";